import $ from 'jquery';
import BaseComponent from '../../../general/js/base-component';

export default class UnderHeroPaneComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.btn = this.refs.toggle;
        this.pane = this.refs.pane;
        this.scrollBtn = this.refs.scroll;

        this.init();
    }

    init() {
        if(typeof this.btn != 'undefined' && typeof this.pane != 'undefined') {
            this.btn.addEventListener('click', this.toggle.bind(this));
        }

        if(typeof this.scrollBtn != 'undefined'){
            this.scrollBtn.addEventListener('click', this.scroll.bind(this));
        }
    }

    toggle(e) {
        e.preventDefault();
        $(this.pane).slideToggle('300', () => {
            this.element.classList.toggle('is-opened');
        });
    }

    scroll(e){
        e.preventDefault();
        $("html, body").stop().animate({ scrollTop: $(this.element).offset().top + $(this.element).outerHeight() - $('.header').outerHeight()}, 500);
    }
}



// WEBPACK FOOTER //
// ./app/components/hero/js/under-hero-pane.component.js